export * from './post-template.service';
export * from './post-template.service.module';